import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Button, Card, Row, Col } from "react-bootstrap";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { API_BREAK_UPDATE, API_BREAK_GET_ONE } from "../../../service/url";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { ROUTES } from "../../../utilities/constant";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditBreak = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [breakData, setBreakData] = useState({});
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    const url = API_BREAK_GET_ONE.replace(":id", id);
    getApiCall(url, {}).then(onListSuccess).catch(onError);
  }, []);

  function onListSuccess(resp) {
    setBreakData(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBreakData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmit = (e) => {
  e.preventDefault();

  // Validate title
  if (!breakData.title?.trim()) {
    toast.error("Break Title is required");
    return;
  }

  // Validate duration
  if (!breakData.duration || breakData.duration.toString().trim() === "") {
    toast.error("Break Duration is required");
    return;
  }

  const durationNum = Number(breakData.duration);
  if (isNaN(durationNum)) {
    toast.error("Break Duration must be a valid number");
    return;
  }

  if (durationNum <= 0) {
    toast.error("Break Duration must be greater than 0");
    return;
  }

  if (durationNum > 1440) {
    toast.error("Break Duration must not exceed 1440 minutes (24 hours)");
    return;
  }

  if (!Number.isInteger(durationNum)) {
    toast.error("Break Duration must be a whole number (no decimals)");
    return;
  }

  setButtonDisable(true);

  const breakWithId = {
    title: breakData.title,
    duration: durationNum.toString(), // Ensure it's a string as backend expects
    description: breakData.description,
    type: breakData.type,
  };

  const url = API_BREAK_UPDATE.replace(":id", id);
  postApiCall(url, breakWithId)
    .then((resp) => {
      onUpdateSuccess(resp);
      setTimeout(() => {
        navigate("/breaks");
      }, 1500);
    })
    .catch(onUpdateError);
};

  function onUpdateSuccess(resp) {
    // setToastProps({
    //   message: "Breaks updated successfully",
    //   type: "success",
    // });
        toast.success("Breaks updated successfully");
    setButtonDisable(false);
  }

  function onUpdateError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
      setButtonDisable(false);
    } else {
      setButtonDisable(false);
      // setToastProps({ message: JSON.stringify(err), type: "danger" });
          toast.error(JSON.stringify(err));
    }
  }

  return (
    <div className="py-4 px-3">
      <Row className="mx-0">
        <Col xs={12}>
          <Card className="border-0 shadow-sm w-100">
            <Card.Body>
              <h2 className="mb-4">Edit Break</h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                 <Form.Label>Break Title <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={breakData.title}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                 <Form.Label>Break Duration (In Minutes) <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="number"
                    name="duration"
                    value={breakData.duration}
                    onChange={handleChange}
                    min="1"
                    max="1440"
                    step="1"
                    onKeyDown={(e) => {
                      if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const pastedValue = e.clipboardData.getData('text');
                      const numValue = Number(pastedValue);
                      if (isNaN(numValue) || numValue <= 0 || numValue > 1440 || !Number.isInteger(numValue)) {
                        e.preventDefault();
                      }
                    }}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Break Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={breakData.description}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Break Type</Form.Label>
                  <Form.Select
                    name="type"
                    value={breakData.type}
                    onChange={handleChange}
                  >
                    <option value="Scheduled">Scheduled</option>
                    <option value="Unscheduled">Unscheduled</option>
                  </Form.Select>
                </Form.Group>

                <div className="d-flex justify-content-end gap-2">
                  <Button
                    variant="secondary"
                    onClick={() => navigate("/breaks")}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={buttonDisable}
                  >
                    Save Changes
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </div>
  );
};

export default EditBreak;
